import { ReactNode } from 'react'

import { StyledList, StyledListItem, ZenkakuSpace } from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const snsItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. General Provisions</h3>
        <p>
          TRIAL Group Social Media Official Account Terms of Use (hereinafter referred to as &apos;these terms&apos;) specify the matters that users of the social media official accounts operated by TRIAL Group (TRIAL Holdings, Inc. and its group companies *) and the associated services (hereinafter collectively referred to as &apos;this service&apos;) must adhere to in using this service (including viewing activities, as similarly defined below).
          <br />
          *Group companies of TRIAL Holdings, Inc. can be found 
          <LinkText path="/en/company/overview/" text="here" />
          .
        </p>
      </>
    ),
    id: 'policy1',
  },
  {
    children: (
      <>
        <h3>2. Scope of these Terms</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            These terms apply to all users of this service.
          </StyledListItem>
          <StyledListItem listType="article">
            If a user use this service, it is considered that they have accepted these terms.
          </StyledListItem>
          <StyledListItem listType="article">
            Various provisions that TRIAL Group presents at any time online or through other means constitute part of these terms. However, if these provisions differ from these terms, the provisions take precedence.
          </StyledListItem>
          <StyledListItem listType="article">
            In the event of any conflict between these terms and the terms of use or policies established by each social media operating company that provides this service, the user shall adhere to the terms and policies of the respective social media operating company.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy2',
  },
  {
    children: (
      <>
        <h3>3. Handling of User information</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            Personal information that users register with TRIAL Group will be held by TRIAL Group, and it will not be provided to third parties without the user&apos;s consent. The registered personal information will only be used for the purposes specified in TRIAL Group&apos;s
            <LinkText
              path="/en/legal/privacy-policy/"
              text="privacy policy"
            />
            .
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group will access information that users have set to be public for all users in this service.
          </StyledListItem>
          <StyledListItem listType="article">
            If a user uses this service, it is considered that they have agreed to the privacy policy established by TRIAL Group.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy3',
  },
  {
    children: (
      <>
        <h3>4. Amendment of these Terms</h3>
        <p>
          TRIAL Group may change these terms without the consent of users. The amended terms will take effect from the time TRIAL Group displays them online.
        </p>
      </>
    ),
    id: 'policy4',
  },
  {
    children: (
      <>
        <h3>5. Prohibited Acts</h3>
        <p>When using this service, the following actions are prohibited:</p>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            Acts that infringe upon the copyrights, portrait rights, or other intellectual property rights of TRIAL Group, other users, or third parties, or acts that may have such implications.
          </StyledListItem>
          <StyledListItem listType="article">
            Acts that infringe upon the property, credibility, privacy, etc., of TRIAL Group, other users, or third parties, or acts that may have such implications.
          </StyledListItem>
          <StyledListItem listType="article">
            Defamatory or slanderous acts against TRIAL Group, other users, or third parties, regardless of truth.
          </StyledListItem>
          <StyledListItem listType="article">
            Sending, transmitting, disclosing, copying, or posting personal information (email addresses, addresses, phone numbers, and other private information) of TRIAL Group and individuals without the prior consent of TRIAL Group or the individual.
          </StyledListItem>
          <StyledListItem listType="article">
            Sending, disclosing, copying, or posting the copyrighted works of other users or third parties without the prior consent of TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            Acts that hinder or destroy the operation of TRIAL Group through viruses, hacking, etc.
          </StyledListItem>
          <StyledListItem listType="article">
            Threats, obscenity, defamation, discriminatory acts, political activities, religious activities, or acts related to these.
          </StyledListItem>
          <StyledListItem listType="article">
            Unauthorized access to computers using borrowed names or addresses.
          </StyledListItem>
          <StyledListItem listType="article">
            Business activities, recruitment activities, or affiliate activities without the prior permission of TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            Acts that hinder the operation of this service or TRIAL Group, acts that undermine the trust of TRIAL Group, or acts that disadvantage other users or TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            Acts contrary to public order and morals, criminal acts, or acts closely related to them.
          </StyledListItem>
          <StyledListItem listType="article">
            Acts that violate laws or regulations or are closely related to such violations.
          </StyledListItem>
          <StyledListItem listType="article">
            Providing or attempting to provide obscene images, audio, text, or similar content.
          </StyledListItem>
          <StyledListItem listType="article">
            Displaying advertising banners, including all types of banner exchanges or link exchanges.
          </StyledListItem>
          <StyledListItem listType="article">
            Posting or endorsing content that may violate pharmaceutical affairs laws.
          </StyledListItem>
          <StyledListItem listType="article">
            Acts prohibited by each social media operating company.
          </StyledListItem>
          <StyledListItem listType="article">
            Any acts contrary to the purpose of this service.
          </StyledListItem>
          <StyledListItem listType="article">
            Other acts deemed inappropriate by TRIAL Group.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy5',
  },
  {
    children: (
      <>
        <h3>6. Measures Against Prohibited Acts</h3>
        <p>
          Regardless of intention or negligence, if TRIAL Group determines that a user has engaged in or may engage in any of the acts listed in the preceding article, TRIAL Group may take one or a combination of the following measures without prior notice:
        </p>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            Deletion of comments or posted content.
          </StyledListItem>
          <StyledListItem listType="article">
            Restriction of the use of the service.
          </StyledListItem>
          <StyledListItem listType="article">
            Warnings or advice through messages or private messages within the platform page.
          </StyledListItem>
          <StyledListItem listType="article">
            Announcement of the measures taken through messages or private messages within the platform page regarding the actions in (1) to (3).
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy6',
  },
  {
    children: (
      <>
        <h3>7. Changes to the Service</h3>
        <p>
          TRIAL Group will provide this service to users based on separate provisions and individual regulations in addition to these terms. TRIAL Group may change the content of this service (including discontinuation) without the consent of the user.
        </p>
      </>
    ),
    id: 'policy7',
  },
  {
    children: (
      <>
        <h3>8. Intellectual Property Rights</h3>
        <p>
          All rights related to copyrights, trademark rights, service marks, patent rights, or other ownership rights, as well as rights protected by law, for all content provided by TRIAL Group in this service, including text, software, music, audio, photos, graphics, videos, page layouts, designs, and other materials, belong to TRIAL Group.
        </p>
      </>
    ),
    id: 'policy8',
  },
  {
    children: (
      <>
        <h3>9. Use by TRIAL Group</h3>
        <p>
          The information such as comments, images, and videos posted by users may be used by TRIAL Group for the purposes of advertising, promotion, and encouraging use in print materials, newsletters, websites, etc., without obtaining the individual&apos;s consent.
        </p>
      </>
    ),
    id: 'policy9',
  },
  {
    children: (
      <>
        <h3>10. Resolution of Disputes</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            In the case of matters not stipulated in these terms, ambiguity in the interpretation of these terms, or if a dispute arises between the user and TRIAL Group, both parties agree to resolve the dispute in good faith.
          </StyledListItem>
          <StyledListItem listType="article">
            In the event that litigation becomes necessary between the user and TRIAL Group, the court with jurisdiction over the headquarters of TRIAL Holdings, Inc., shall be the exclusive agreed jurisdictional court for the first instance.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy10',
  },
  {
    children: (
      <>
        <h3>11. Disclaimer</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            TRIAL Group does not provide any legal guarantee or assume any responsibility for the accuracy, usefulness, currency, appropriateness, etc., of all information provided by users to all users of this service.
          </StyledListItem>
          <StyledListItem listType="article">
            The use of this service may be affected by the user&apos;s browser and viewing environment. TRIAL Group shall not be responsible for any damages arising from the user&apos;s inability to use this service.
          </StyledListItem>
          <StyledListItem listType="article">
            Social media platforms are operated by external corporations, and TRIAL Group does not guarantee their functionality or safety. TRIAL Group also cannot provide answers regarding the operation of external corporate social media, the functionality of software and mobile applications, how to use them, or technical inquiries.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group is not responsible for any damage caused to users by using sites other than TRIAL Group linked from this service (hereinafter referred to as &quot;linked sites&quot;). TRIAL Group is not responsible for the content of linked sites or the handling of personal information on it. Even if a linked site is interrupted or stopped, TRIAL Group assumes no responsibility for any damages incurred by users.
          </StyledListItem>
          <StyledListItem listType="article">
            Not all posts and comments will receive a response.
          </StyledListItem>
          <StyledListItem listType="article">
            Official announcements and views of TRIAL Group are made on TRIAL Group&apos;s website and through press releases, among other channels. Information posted by TRIAL Group and its employees on this service does not necessarily represent the official announcements or views of TRIAL Group. Additionally, user-generated content posted by users may not reflect the opinions or ideals of TRIAL Group and its employees and affiliates. TRIAL Group does not guarantee the accuracy of statements or claims made on this service.
          </StyledListItem>
          <StyledListItem listType="article">
            If TRIAL Group deems any information posted by users on this service as inappropriate, TRIAL Group may, at its discretion, delete such information without disclosing the reasons to the user. However, TRIAL Group does not guarantee that it will monitor or inspect the information posted by users on this service based on the provisions of this section.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group shall not be held responsible for any damages caused or related to a user&apos;s use of this service that affects other users or third parties, or damages caused or related to a third party&apos;s viewing of this service that affects the user (including cases where a malicious third party collects personal information through any means, leading to damages incurred by the user).
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group does not provide any guarantee regarding the quality or performance of this service to users. Additionally, TRIAL Group assumes no responsibility for the temporary suspension, cessation, defects, and any losses or damages arising from or related to them.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group may, after providing prior notice online, terminate or delete part or all of this service. TRIAL Group shall be exempt from liability for damages incurred by users and third parties due to the termination of this service.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy11',
  },
  {
    children: (
      <>
        <p>
          Date of Enactment:
          <ZenkakuSpace />
          June 23,2020
          <br />
          Date of Last Revision:
          <ZenkakuSpace />
          December 26,2022
        </p>
      </>
    ),
    id: 'signdate',
  },
]

export const snsLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（General Provisions）',
      anchor: 'policy1',
    },
    {
      name: '（Scope of these Terms）',
      anchor: 'policy2',
    },
    {
      name: '（Handling of User information）',
      anchor: 'policy3',
    },
  ],
  [
    {
      name: '（Amendment of these Terms）',
      anchor: 'policy4',
    },
    {
      name: '（Prohibited Acts）',
      anchor: 'policy5',
    },
    {
      name: '（Measures Against Prohibited Acts）',
      anchor: 'policy6',
    },
  ],
  [
    {
      name: '（Changes to the Service）',
      anchor: 'policy7',
    },
    {
      name: '（Intellectual Property Rights）',
      anchor: 'policy8',
    },
    {
      name: '（Use by TRIAL Group）',
      anchor: 'policy9',
    },
  ],
  [
    {
      name: '（Resolution of Disputes）',
      anchor: 'policy10',
    },
    {
      name: '（Disclaimer）',
      anchor: 'policy11',
    },
  ],
]
